import Vue from 'vue';
import axios from 'axios';
import customer from '../employee/enquiries/customer';

export default {
  name: 'SendEmail',
  components: {
    DataGridComp: require('./datagrid.vue').default,
  },
  props: {
    dataSource: {
      type: Array,
      required: true
    },
    dataSourceFun: {
      type: Function,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    emailFrom: {
      type: String,
      required: true,
    },
    emailReadOnly: {
      type: Boolean,
      default: true
    },
    currentTab: {
      type: String,
    },
    recepients: {
      type: Array
    },
    parent: {
      type: Object,
      required: true
    },
    customerList: {
      type: Array,
    },
    reportName: {
      type: String,
      required: true
    },
    sourceId: {
      type: Number,
      required: true
    },
    sourceType: {
      type: Number,
      required: true
    },
    applicationId: {
      type: String,
      required: true
    },
    sampleId: {
      type: Number,
      required: true
    },
    exitFunc: {
      type: Function,
      required: true
    }
  },
  data: function () {
    return {
      selectedItem: null,
      subject: '',
      body: '',
      selectedEmails: [],
      sendEmailTabState: 'tab-cust-list',
      detailsTabState: 'tab-details',
      selectedEmailsConfig: [],
      selectedEmailsPageingOption: {
        pageSize: 1000, total: 0, page: 1
      },
      filesList: [],
      formData: new FormData(),
    }
  },
  computed: {
    tabDisabled() {
      return this.selectedEmails.length > 0 ? false : true;
    },
    getSubject() {
      return "Subject: " + this.reportName;
    }
  },
  watch: {
    subject: function (sub) {
      //email subject cannot be empty
      if (sub == '') {
       this.$alertMsg(this.$t('sendEmail.emptySubject'), 3);
        this.subject = this.getSubject;
      }
    }
  },
  created() {
    this.fillSelectedEmailsConfig();
    this.subject = this.getSubject;
  },
  methods: {
    processFiles(event) {
      if (event.target.files.length === 0)
        return;

      for (var i = 0; i < event.target.files.length; ++i) {
        this.formData.append("Files", event.target.files[i]);
        this.filesList.push({ name: event.target.files[i].name });
      }
    },
    sendEmail() {
      let customerKeys = [];
      //build customer keys array
      this.selectedEmails.forEach(em => customerKeys.push(em.customerKey));

      //error traps
      if (customerKeys.length <= 0) {
        this.$alertMsg(this.$t('sendEmail.noCustomeKeys'));
        return;
      }

      //create data object to send
      this.formData.append("ReportName", this.reportName);
      this.formData.append("SourceId", this.sourceId);
      this.formData.append("SourceType", this.sourceType);
      this.formData.append("Custkeys", this.customerKeys);
      this.formData.append("Subject", this.subject);
      this.formData.append("Body", this.body);
      this.formData.append("ApplicationId", this.applicationId);
      this.formData.append("SampleId", this.sampleId);

      axios.post('/DxReport/EmailReport', this.formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('sendEmail.emailSent'), 2);
            this.exitFunc();
          }
          else
            this.$alertMsg(response.data.data.text);
        })
        .catch(e => {
          console.log("error",e);
          this.$alertMsg(this.$t('messages.FilesAllowed'));
        });
    },
    addAttachment() {
      var iCntrl = document.getElementById('upload');
      iCntrl.click();
    },
    removeAttachments(index) {
      this.formData = null;
      this.formData = new FormData();
      this.filesList = [];
    },
    addEmails() {
      //send selected emails for processing
      this.selectedEmails = this.dataSource.filter(element => element['selected']);
      if (this.selectedEmails.length > 0)
        this.changeSendEmailTab('tab-emails');
    },
    clearEmailSelection() {
      this.dataSource.forEach(element => element['selected'] = false);
      this.selectedEmails = [];
      this.$alertMsg(this.$t('messages.emailsCleared'));
    },
    rowRemove(info) {
      //console.log("info", info);
      let custKey = this.selectedEmails[info.dataIndex].customerKey;
      //remove customer from list
      this.selectedEmails.splice(info.dataIndex, 1);

      //remove selection from datasource
      this.dataSource.forEach(element => {
        if (element.customerKey == custKey) {
          element['selected'] = false;
          return;
        }
      });

      if (this.selectedEmails.length <= 0)
        this.changeSendEmailTab('tab-cust-list');

      this.$alertMsg(this.$t('sendEmail.successDelete'), 2);
    },
    pageChange(pInfo) {
      if (this.config.pageOptions.page == pInfo.pageNumber && this.config.pageOptions.pageSize == pInfo.pageSize)
        return;

      this.config.pageOptions.page = pInfo.pageNumber;
      this.config.pageOptions.pageSize = pInfo.pageSize;
      this.dataSourceFun(this.config.pageOptions);
    },
    rowSelected(info) {
      this.selectedObj = info.data;
      //error trap
      if (!this.selectedObj)
        return;

      //check if element is in the list before adding it
      if (this.selectedEmails.indexOf(this.selectedObj) < 0) {
        this.selectedEmails.push(this.selectedObj);
        this.dataSource[info.rowIndex].selected = true;
      }
    },
    fillSelectedEmailsConfig() {
      this.selectedEmailsConfig['keyColumn'] = 'email';
      this.selectedEmailsConfig['pageOptions'] = this.selectedEmailsPageingOption;
      this.selectedEmailsConfig['totalRows'] = 0;
      this.selectedEmailsConfig['cols'] = [];
      this.selectedEmailsConfig['cols'].push({ caption: this.$t('sendEmail.email'), dataField: 'email' });
      this.selectedEmailsConfig['cols'].push({ caption: this.$t('sendEmail.name'), dataField: 'surname' });
    },
    changeSendEmailTab(e) {
      this.sendEmailTabState = e;
    },
    changedetailsTab(e) {
      this.detailsTabState = e;
    },
    validateAppData() {
      return true;
    },   
  }
}

